import dayjs from 'dayjs';
import { CHART_TITLE_HORAS_FRIO_ACUMULADAS } from '../../../../constants/graphs';
import { ColdHoursConfigType } from './types';
import { FormConfig } from '../../utils/DayMonthBaseForm';

export const FORM_CONFIGS: FormConfig[] = [
  {
    title: 'Configuración Serie Horas Frío',
    startMonthField: 'coldHoursStartMonth',
    startDayField: 'coldHoursStartDay',
    baseTempField: 'coldHoursBaseTemp',
    endMonthField: 'coldHoursEndMonth',
    endDayField: 'coldHoursEndDay',
  },
  {
    title: 'Configuración Grados Día Acumulados',
    startMonthField: 'accumulatedDegreesStartMonth',
    startDayField: 'accumulatedDegreesStartDay',
    baseTempField: 'accumulatedDegreesBaseTemp',
    endMonthField: 'accumulatedDegreesEndMonth',
    endDayField: 'accumulatedDegreesEndDay',
  },
];

export const DEFAULT_CHART_PROPS = {
  height: 600,
  title: CHART_TITLE_HORAS_FRIO_ACUMULADAS,
  yAxisTitle: 'Horas Frío Acumuladas',
  hideLegend: false,
  hideXValues: false,
  hideYValues: false,
} as const;

export const buildDateRangesFromMonthDay = (
  startMonth: number,
  startDay: number,
  endMonth: number,
  endDay: number,
  referenceStartDate: string,
  referenceEndDate: string,
): Array<{ startDate: string; endDate: string }> => {
  const startRef = dayjs(referenceStartDate);
  const endRef = dayjs(referenceEndDate);
  const ranges: Array<{ startDate: string; endDate: string }> = [];

  const crossesYears = endMonth < startMonth
    || (endMonth === startMonth && endDay < startDay);

  const startYear = startRef.year();
  const endYear = endRef.year();

  for (let year = startYear; year <= endYear; year += 1) {
    let rangeStart = dayjs().year(year).month(startMonth - 1).date(startDay)
      .startOf('day');
    let rangeEnd: dayjs.Dayjs;

    if (crossesYears) {
      rangeEnd = dayjs().year(year + 1).month(endMonth - 1).date(endDay)
        .startOf('day');
    } else {
      rangeEnd = dayjs().year(year).month(endMonth - 1).date(endDay)
        .startOf('day');
    }

    if (rangeStart.isBefore(startRef)) {
      rangeStart = startRef;
    }

    if (rangeEnd.isAfter(endRef)) {
      rangeEnd = endRef;
    }

    if (rangeStart.isSameOrBefore(rangeEnd) && rangeEnd.isSameOrAfter(startRef)) {
      ranges.push({
        startDate: rangeStart.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: rangeEnd.format('YYYY-MM-DDTHH:mm:ss'),
      });
    }
  }

  return ranges;
};

export const getDateRange = (
  config: ColdHoursConfigType,
  reduxDates: { startDate: string; endDate: string },
) => {
  const coldHoursRanges = buildDateRangesFromMonthDay(
    config.coldHoursStartMonth,
    config.coldHoursStartDay,
    config.coldHoursEndMonth,
    config.coldHoursEndDay,
    reduxDates.startDate,
    reduxDates.endDate,
  );

  const accumulatedDegreesRanges = buildDateRangesFromMonthDay(
    config.accumulatedDegreesStartMonth,
    config.accumulatedDegreesStartDay,
    config.accumulatedDegreesEndMonth,
    config.accumulatedDegreesEndDay,
    reduxDates.startDate,
    reduxDates.endDate,
  );

  return { coldHoursRanges, accumulatedDegreesRanges };
};
